/* eslint-disable  @typescript-eslint/restrict-plus-operands */
/* eslint-disable  react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Typography, Row, Tooltip, Spin, message, Popconfirm } from 'antd';
import styled from 'styled-components';
import Text from 'antd/lib/typography/Text';
import { useDispatch, useSelector } from 'react-redux';
import {
  CloseCircleFilled,
  DeleteOutlined,
  ExclamationCircleFilled,
  SaveFilled,
  LoadingOutlined,
} from '@ant-design/icons';
import { setOpencarholdereditModal, setEditedNodeDetails, setDeleteNode } from '~/slices/state';
import colors from '~/constants/colors';
import { EditIcon } from '~/img';
import buildNamePath from '~/utils/buildNamePath';
import CustomTooltip from '~/components/OpenedToolTip';
import { getCardholderContactId } from '~/api/contacts';
import { contactObjCreation } from '~/utils/contacts';
import { useMutateContactsApi } from '~/controllers/contacts';
import { isSales } from '~/utils/getDecodedJwt';
import { useAmendment } from '~/controllers/amendment';
// import message from '~/i18n/en/message';
import { physicalCards } from '..';

const levelsColors: any = {
  company: '#f9f9f9b2',
  region: '#f9f9f9b2',
  branch: '#f9f9f9b2',
  department: '#f9f9f9b2',
  cardholder: '#afd4fb2b',
};
const textLevelsColors: any = {
  company: '#f4f3f3b9',
  region: '#f4f3f3b9',
  branch: '#f4f3f3b9',
  department: '#f4f3f3b9',
  cardholder: '#afd4fb17',
};

function TreeTitle(props: any) {
  const { value, valueName, nodeKey, productKey, status = 'IN_PROGRESS', productLocked } = props;
  const modifyModeKey = nodeKey.startsWith('productKey') ? nodeKey : `productKey-${productKey}-${nodeKey}`;
  const isNodeReadOnly = !!productLocked && valueName !== 'cardholder';
  const contactMutation = useMutateContactsApi();
  const stateGlob = useSelector((state: any) => state.state);
  const [modal1Open, setModal1Open] = useState(false);
  const [showMinimumCardholderErr, setShowMinimumCardholderErr] = useState(false);
  const isItPysical = physicalCards.includes(productKey);
  const {
    nodeDetails: nodeDetailsData,
    hierarchylevels,
    leafNodesHaveNocardholders = {},
    applicationStage,
    hierarchyErr,
  } = stateGlob;
  const levelOrder = hierarchylevels.indexOf(valueName);
  const [editInput, setEditInput] = useState(false);
  const [editedValue, setEditedValue] = useState(value);
  const [statusLoading, setStatusLoading] = useState(false);
  const dispatch = useDispatch();
  const n = buildNamePath('cardOrderDetails');
  const statusText = status === 'RECEIVED_CONSENT' ? 'Completed' : 'Pending';
  const sales = isSales();
  const { isAmendment } = useAmendment();

  function editHandler() {
    if (valueName === 'cardholder') {
      dispatch(setOpencarholdereditModal<any>(true));
    } else {
      setEditInput((prev) => !prev);
    }
  }
  useEffect(() => {
    setEditedValue(value);
  }, [value]);

  function saveEditedInputHandler() {
    if (valueName === 'cardholder') {
      dispatch(setOpencarholdereditModal<any>(true));
    } else {
      if (!editedValue?.trim()) {
        void message.error(`${valueName} name is empty`);
        return null;
      }
      if (!/^[a-zA-Z ]*$/.test(editedValue)) {
        void message.error('Text only is allowed');
        return null;
      }
      dispatch(setEditedNodeDetails<any>({ value: editedValue, type: valueName }));
      setEditInput((prev) => !prev);
      setEditedValue(editedValue);
    }
    return null;
  }

  async function deleteNodeHandler() {
    if (valueName === 'cardholder') {
      const isItPysical = nodeDetailsData?.cardHolderValues?.email;
      try {
        if (isItPysical) {
          console.log('==========', nodeDetailsData?.cardHolderValues);
          const getcardholderData = await getCardholderContactId(
            nodeDetailsData?.cardHolderValues?.mobile,
            nodeDetailsData?.cardHolderValues?.email,
          );
          contactMutation.mutate(
            contactObjCreation(getcardholderData[0], {
              type: 'DELETE',
              role: productKey === 'CORPORATE_EXECUTIVE_CARD' ? 'cardholder' : 'businessCardholder',
            }),
          );
          console.log('nodeDetailsData', nodeDetailsData);
          dispatch(setDeleteNode<any>(true));
        } else {
          dispatch(setDeleteNode<any>(true));
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      dispatch(setDeleteNode<any>(true));
    }
  }

  useEffect(() => {
    const checkKeyunderErr = leafNodesHaveNocardholders[productKey]?.find(
      (item: any) => item?.uniqueId === modifyModeKey,
    );
    if (Object.keys(checkKeyunderErr || {}).length) {
      setShowMinimumCardholderErr(true);
    } else {
      setShowMinimumCardholderErr(false);
    }
  }, [leafNodesHaveNocardholders, productKey, modifyModeKey]);

  useEffect(() => {
    if (hierarchyErr) {
      setStatusLoading(true);
      setTimeout(() => {
        setStatusLoading(false);
      }, 600);
    }
  }, [hierarchyErr]);

  return (
    <>
      <TreeTitleContainer
        levelsColors={levelsColors}
        levelOrder={levelOrder}
        showMinimumCardholderErr={showMinimumCardholderErr}
        hierarchylevels={hierarchylevels}
        valueName={valueName}
        status={status}
        isItPysical={isItPysical}
      >
        <div className="treeNode">
          <Row justify="space-between" style={{ width: '100%' }}>
            <Col span={18}>
              {!editInput && (
                <Row>
                  <Col>
                    <div className="nameStyle">
                      <Text style={{ fontSize: '13px', marginRight: '10px' }} strong>
                        {value}
                      </Text>
                    </div>
                  </Col>
                  <Col>
                    <Text style={{ color: colors.red[1100], fontSize: '12px' }} strong>
                      {isItPysical
                        ? `  - ${valueName?.charAt(0).toUpperCase() + valueName.slice(1)}`
                        : valueName === 'cardholder'
                        ? '- Custodian'
                        : `  - ${valueName?.charAt(0).toUpperCase() + valueName.slice(1)}`}
                    </Text>
                  </Col>
                </Row>
              )}
              {editInput && (
                <input
                  className="inputText"
                  onChange={(e: any) => setEditedValue(e?.target?.value)}
                  value={editedValue}
                />
              )}
            </Col>

            {valueName !== 'company' && (
              <>
                {isItPysical &&
                  valueName === 'cardholder' &&
                  (statusLoading ? (
                    <Spin
                      indicator={<LoadingOutlined style={{ fontSize: 24, position: 'absolute', right: '20%' }} spin />}
                    />
                  ) : (
                    <div className="statusText">{statusText}</div>
                  ))}
                {valueName !== 'cardholder' && (
                  <Col span={2}>
                    <></>
                  </Col>
                )}
                {valueName === 'cardholder' && !isItPysical && (
                  <Col span={2}>
                    <></>
                  </Col>
                )}
                <Col span={1}>
                  <Button
                    disabled={
                      applicationStage !== 'fillApplication' ||
                      isNodeReadOnly ||
                      (valueName !== 'cardholder' && isAmendment)
                    }
                    type="ghost"
                    onClick={() => setModal1Open(true)}
                    className="actionButtons"
                    size="small"
                    icon={<DeleteOutlined className="actionIcons" />}
                  />
                </Col>
                {!editInput && (
                  <Col span={1}>
                    <Button
                      disabled={
                        (valueName !== 'cardholder' && isAmendment) ||
                        isNodeReadOnly ||
                        (!sales &&
                          (applicationStage !== 'fillApplication' ||
                            (status === 'RECEIVED_CONSENT' && valueName === 'cardholder')))
                      }
                      type="ghost"
                      className="actionButtons"
                      onClick={() => editHandler()}
                      size="small"
                      icon={<EditIcon className="actionIcons" />}
                    />
                  </Col>
                )}
                {editInput && editedValue && (
                  <Col span={1}>
                    <Popconfirm
                      title="Value will be changed over all the products"
                      onConfirm={() => {
                        saveEditedInputHandler();
                      }}
                      onOpenChange={() => console.log('open change')}
                    >
                      <Button
                        type="ghost"
                        disabled={!editedValue}
                        className="actionButtons"
                        size="small"
                        icon={<SaveFilled className="actionIcons" />}
                      />
                    </Popconfirm>
                  </Col>
                )}
                {editInput && (
                  <Col span={1}>
                    <Button
                      type="ghost"
                      onClick={() => setEditInput((prev) => !prev)}
                      className="actionButtons"
                      size="small"
                      icon={<CloseCircleFilled className="actionIcons" />}
                    />
                  </Col>
                )}
              </>
            )}
          </Row>
          {showMinimumCardholderErr && (
            <div style={{ position: 'absolute', right: '-25px' }}>
              <CustomTooltip
                type="error"
                text={`Minmum 1 ${isItPysical ? 'cardholder' : 'custodian'}  should be added`}
                width={300}
              />
            </div>
          )}
        </div>
        <>
          <Modal
            title={<DeleteOutlined />}
            centered
            visible={modal1Open}
            onOk={() => deleteNodeHandler()}
            onCancel={() => setModal1Open(false)}
            okText="Delete"
          >
            <p>
              {' '}
              <span style={{ color: 'black', fontWeight: 700 }}>
                {' '}
                {value}_{valueName}
              </span>{' '}
              will be deleted over all the products .
            </p>
          </Modal>
        </>
      </TreeTitleContainer>
    </>
  );
}
const TreeTitleContainer = styled.div<any>`
  .statusText {
    color: ${({ status }: any) => {
      return status === 'RECEIVED_CONSENT' ? '#23ef4f' : '#efa423';
    }};
    font-weight: 700;
    text-shadow: 1px 1px #faf3f3;
  }
  /* RECEIVED_CONSENT */
  .nameStyle {
    border-radius: 3px;
    background: ${({ levelOrder }: any) => {
      switch (levelOrder) {
        case 0:
          return '#F6F6F6';
        case 1:
          return '#DBE8F3';
        case 2:
          return '#F2F7FB';
        default:
          return 'white';
      }
    }};
    min-width: ${({ valueName }: any) => {
      if (valueName === 'cardholder') {
        return 240;
      }
      return 220;
    }}px;
    text-align: center;
  }
  .actionButtons {
    /* position: 'absolute'; */
    height: 18px !important;
    /* right: -5px; */
    /* background-color: green; */
    /* top: 0; */
    border-width: 0px;
    /* margin-right: 10px; */
  }
  .actionIcons {
    color: ${colors.red[1100]};
    font-size: 14px;
    /* position: 'absolute'; */
    /* right: -5px; */
  }
  .inputText {
    border-width: 0.8px;
    border-style: solid;
    position: absolute;
    border-radius: 3px;
    border-color: ${colors.red[1100]};
    top: 0;
    width: 90%;
    height: 25px !important;
    width: 220px;
  }
  .inputText:focus {
    border-width: 0.8px;
    border-style: solid;
    position: absolute;
    border-radius: 3px;
    border-color: ${colors.red[1100]};
  }
  .typeTitle {
    position: absolute;
    right: 155px;
  }
  .validationDiv {
    position: absolute;
    bottom: 0px;
    left: 20%;
    padding-left: 10px;
    padding-right: 10px;
    height: 12px;
    background-color: white;
    background: white;
    z-index: 6;
  }
  .validationText {
    color: ${colors.red[1100]};
    font-size: 12px;
  }
  .cardBoxContainer {
    /* position: relative; */
    width: 40px;
    /* background-color: ${colors?.grey[1100]}; */
    text-align: center;
    align-items: center;
    align-self: center;
    align-content: center;
  }
  .treeNode {
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;

    border: ${({ showMinimumCardholderErr }: any) => {
      if (showMinimumCardholderErr) {
        return '1.5px solid red';
      }
      return '#dedede';
    }};

    /* border-width: 1px; */
    /* border-right: 1px solid #dedede; */
    border-radius: 3px;
    display: flex;

    background: ${({ levelOrder }: any) => {
      switch (levelOrder) {
        case 0:
          return '#F6F6F6';
        case 1:
          return '#DBE8F3';
        case 2:
          return '#F2F7FB';
        default:
          return 'white';
      }
    }};
    width: ${({ hierarchylevels, valueName }: any) => {
      const levelCurrentTitle = hierarchylevels.indexOf(valueName);
      return 700 - levelCurrentTitle * 25;
    }}px;
    height: 35px;

    @media (max-width: 1475px) and (min-width: 1281px) {
      width: ${({ hierarchylevels, valueName }: any) => {
        const levelCurrentTitle = hierarchylevels.indexOf(valueName);
        return 43 - levelCurrentTitle * 1.7;
      }}vw;
    }

    @media (max-width: 1145px) and (min-width: 1023px) {
      width: ${({ hierarchylevels, valueName }: any) => {
        const levelCurrentTitle = hierarchylevels.indexOf(valueName);
        return 60 - levelCurrentTitle * 2;
      }}vw;
    }
    //
    /* position: absolute; */
    /* right: 10px; */
    /* width: 100%; */
    /* height: 42px; */
    padding: 12px 0px 12px 12px;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }

  /* position: absolute; */
  /* right: 0;
  width: 100%; */
  /* background-color: red; */
`;

export default TreeTitle;
